export const decodeText = (text: string) => {
  if (typeof text !== "string") {
    return text;
  }

  // Check if is a URL or text and apply the correct decoding
  if (text.includes("http") || text.includes("https")) {
    return decodeURI(text);
  }

  return decodeURIComponent(text);
};
